module.exports = __webpack_public_path__ + "img/19A8D0@2x.e21a813b.png";